/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFavoritedResults, speak } from '../actions';
import SideBar from '../components/SideBar';
import Buckets from '../components/Buckets';
import Welcome from '../assets/dashboard/favorites/welcome.svg';

class Favorites extends Component {
  componentDidMount() {
    this.props.getFavoritedResults(this.props.userid);
  }

  render() {
    return (
      <div className="dashboard-container">
        <SideBar defaultPage="favorites" />
        <div className="dashboard-body-container" id="scroll-container">
          <div className="dashboard-body-subcontainer">
            <div className="box favorites-welcome-box">
              <div>
                <h2 onClick={this.props.speak} className={`color ${this.props.speechEnabled && 'bolded'}`}>{`${this.props.username}'s Favorite Tools`}</h2>
                <p onClick={this.props.speak} className={`color ${this.props.speechEnabled && 'bolded'}`}>
                  View all of your favorited tools to expand your mind.
                </p>
              </div>
              <img src={Welcome} alt="welcome" />
            </div>
            <Buckets
              buckets={this.props.favorites}
              pdfName="Favorite"
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => (
  {
    userid: state.user.userid,
    favorites: state.favorites.buckets,
    username: state.user.firstName,
    speechEnabled: state.speech.enabled,
  }
);

export default connect(mapStateToProps, { getFavoritedResults, speak })(Favorites);
